/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Ai_Markup_ActionInputs */

const cs_templates_ai_markup_action = /** @type {(inputs: Templates_Ai_Markup_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Převést na layout`)
};

const en_templates_ai_markup_action = /** @type {(inputs: Templates_Ai_Markup_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert to layout`)
};

/**
* | output |
* | --- |
* | "Convert to layout" |
*
* @param {Templates_Ai_Markup_ActionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_ai_markup_action = /** @type {((inputs?: Templates_Ai_Markup_ActionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Ai_Markup_ActionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_ai_markup_action(inputs)
	return cs_templates_ai_markup_action(inputs)
});